import React, { useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';

import { FreeMode, Navigation, Thumbs } from 'swiper/modules';


function ProductSlider({ images }) {
    const [thumbsSwiper, setThumbsSwiper] = useState(null);
    return (
        <div>
            {images?.length > 0 ? <div className="product-slider">


                <Swiper
                    style={{
                        '--swiper-navigation-color': '#fff',
                        '--swiper-pagination-color': '#fff',
                    }}
                    spaceBetween={10}
                    // navigation={true}
                    thumbs={{ swiper: thumbsSwiper }}
                    modules={[FreeMode, Navigation, Thumbs]}
                    className="mySwiper2"
                >
                    {images.map((item, ind) => <SwiperSlide key={ind}><img src={item.ZoomUrl} /></SwiperSlide>)}
                </Swiper>
                <Swiper
                    style={{ padding: '10px 35px ' }}
                    onSwiper={setThumbsSwiper}
                    spaceBetween={40}
                    padding={25}
                    navigation={true}
                    slidesPerView={4}

                    freeMode={true}
                    watchSlidesProgress={true}
                    modules={[FreeMode, Navigation, Thumbs]}
                    className="mySwiper"
                >
                    {images.map((item, ind) => <SwiperSlide key={ind}><img src={item.ThumbnailUrl} /></SwiperSlide>)}
                </Swiper>

            </div> : <></>}

        </div>
    )
}

export default ProductSlider
